import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';

/** Adapta só Gerentes para notificação única pelo interceptor existente. */
export const gerenteProblemDetailsInterceptor: HttpInterceptorFn = (req, next) => {
  const base = `${environment.apiUrl}/api/gerentes`;
  if (req.url !== base && !req.url.startsWith(`${base}/`) && !req.url.startsWith(`${base}?`)) return next(req);
  return next(req).pipe(catchError((error: HttpErrorResponse) => {
    const body = error.error;
    if (body && typeof body === 'object') {
      // Array (ResultDto) ou dicionário (ValidationProblemDetails): só mensagens textuais seguem para o alerta.
      const brutos: unknown[] = Array.isArray(body.errors) ? body.errors
        : body.errors && typeof body.errors === 'object' ? Object.values(body.errors).flat() : [];
      const errors = brutos.filter((v): v is string => typeof v === 'string');
      const message = typeof body.detail === 'string' && body.detail.length ? body.detail : body.message;
      if (message || errors.length) return throwError(() => new HttpErrorResponse({
        error: { ...body, message, errors }, headers: error.headers, status: error.status,
        statusText: error.statusText, url: error.url ?? undefined
      }));
    }
    return throwError(() => error);
  }));
};
